var map = {
	"./template.bet575": 1660,
	"./template.bet575.tsx": 1660,
	"./template.bet777": 2093,
	"./template.bet777.tsx": 2093,
	"./template.betbetbet": 2094,
	"./template.betbetbet.tsx": 2094,
	"./template.betgalaxy": 2095,
	"./template.betgalaxy.tsx": 2095,
	"./template.betprofessor": 2008,
	"./template.betprofessor.tsx": 2008,
	"./template.betroyale": 2096,
	"./template.betroyale.tsx": 2096,
	"./template.betstride": 2097,
	"./template.betstride.tsx": 2097,
	"./template.buffalobet": 2098,
	"./template.buffalobet.tsx": 2098,
	"./template.chromabet": 2099,
	"./template.chromabet.tsx": 2099,
	"./template.default": 674,
	"./template.default.tsx": 674,
	"./template.epicodds": 2100,
	"./template.epicodds.tsx": 2100,
	"./template.fiestabet": 2009,
	"./template.fiestabet.tsx": 2009,
	"./template.forsport": 1661,
	"./template.forsport.tsx": 1661,
	"./template.gigabet": 2101,
	"./template.gigabet.tsx": 2101,
	"./template.goldenbet888": 1662,
	"./template.goldenbet888.tsx": 1662,
	"./template.goldenrush": 2102,
	"./template.goldenrush.tsx": 2102,
	"./template.hyperbet": 2103,
	"./template.hyperbet.tsx": 2103,
	"./template.juicybet": 1663,
	"./template.juicybet.tsx": 1663,
	"./template.junglebet": 1664,
	"./template.junglebet.tsx": 1664,
	"./template.magnumbet": 2104,
	"./template.magnumbet.tsx": 2104,
	"./template.oldgill": 1665,
	"./template.oldgill.tsx": 1665,
	"./template.puntcity": 1666,
	"./template.puntcity.tsx": 1666,
	"./template.puntgenie": 2105,
	"./template.puntgenie.tsx": 2105,
	"./template.pyramidbet": 2106,
	"./template.pyramidbet.tsx": 2106,
	"./template.questbet": 1667,
	"./template.questbet.tsx": 1667,
	"./template.slambet": 2010,
	"./template.slambet.tsx": 2010,
	"./template.sterlingparker": 2011,
	"./template.sterlingparker.tsx": 2011,
	"./template.sugarcastle": 2107,
	"./template.sugarcastle.tsx": 2107,
	"./template.templebet": 2108,
	"./template.templebet.tsx": 2108,
	"./template.titanbet": 2109,
	"./template.titanbet.tsx": 2109,
	"./template.ts": 89,
	"./template.vikingbet": 1668,
	"./template.vikingbet.tsx": 1668,
	"./template.volcanobet": 2110,
	"./template.volcanobet.tsx": 2110,
	"./template.wellbet": 1669,
	"./template.wellbet.tsx": 1669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2469;